import React from 'react';
import { FormikHelpers } from 'formik';

export type LoginValues = {
  email?: string;
  password?: string;
  confirmPassword?: string;
  code?: string | null;
  token?: string;
  userId?: string;
  language?: string;
  avatarName?: string;
  avatarColor?: string;
  firstName?: string;
  lastName?: string;
  username?: string;
  classCode?: string;
};

export type LoginStepProps = {
  emitSubmit?: (values: LoginValues, formikHelpers: FormikHelpers<LoginValues>) => void;
  loading?: boolean;
  styles: Record<string, string>;
};

export type InitialLoginProps = LoginStepProps & {
  goToResetPassword?: () => void;
  setLoginError?: React.Dispatch<React.SetStateAction<string | null>>;
};

export type ConfirmVerificationCodeProps = LoginStepProps & {};

export type ForgotPasswordProps = LoginStepProps & {};

export type ConfirmForgotPasswordProps = LoginStepProps & {
  resendForgotPassword?: () => void;
};

export type CognitoPasswordChangeProps = LoginStepProps & {};

export type LoginSteps = {
  type: LoginStep;
  title?: string;
  subTitle?: string;
  component: React.FC<InitialLoginProps | ConfirmVerificationCodeProps>;
};

export type ClassCodeUserValues = {
  firstName: string;
  lastName: string;
  username: string;
  password: string;
};

export type SessionSetupParams = {
  firstName: string;
  lastName: string;
  username: string;
  userId: string;
  classCode: string;
  authResult: any;
};

export enum LoginStep {
  LOGIN,
  MG_LOGIN,
  CONFIRM_VERIFICATION_CODE,
  FORGOT_PASSWORD,
  CONFIRM_FORGOT_PASSWORD,
  COGNITO_PASSWORD_CHANGE,
  AVATAR_UPDATE,
  LOGIN_ERROR,
  CLASS_CODE,
  CLASS_CODE_REGISTRATION,
  CLASS_CODE_ERROR,
}
